let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4n0mT")).then(() => parcelRequire('jxQ2s'));